module.exports = __webpack_public_path__ + "images/home/devices@2x-a9c1e5d284b87e1b0b0ffed473937451.png";